import React from "react";

/** Right-side / mobile hero — responsive assets (exact filenames in public/Assets/Images) */
const HERO_IMAGES = {
  sm: { src: "/Assets/Images/Logo-220-165.png", width: 220, height: 165 },
  md: { src: "/Assets/Images/logo-264-198.png", width: 264, height: 198 },
  lg: { src: "/Assets/Images/Logo-484-363.png", width: 484, height: 363 },
};

const LoginHeroImage = ({ className = "login-image" }) => (
  <picture className="login-hero-picture">
    <source media="(max-width: 768px)" srcSet={HERO_IMAGES.sm.src} />
    <source media="(max-width: 1024px)" srcSet={HERO_IMAGES.md.src} />
    <img
      src={HERO_IMAGES.lg.src}
      alt="Adukkumadi"
      className={className}
      width={HERO_IMAGES.lg.width}
      height={HERO_IMAGES.lg.height}
      loading="eager"
      decoding="async"
    />
  </picture>
);

export default LoginHeroImage;
